import { render } from "./CloudTableComponent.vue?vue&type=template&id=6afe89b9"
import script from "./CloudTableComponent.vue?vue&type=script&lang=js"
export * from "./CloudTableComponent.vue?vue&type=script&lang=js"

import "./CloudTableComponent.vue?vue&type=style&index=0&id=6afe89b9&lang=css"

import exportComponent from "/var/www/html/lynkto-vlan-user-panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__